/**
 * @author      joseph.murphy@zumper.com (murph)
 * @copyright   Copyright (c) 2022, Zumper
 */

// https://chakra-ui.com/docs/styled-system/theming/component-style#styling-single-part-components

import { ComponentStyleConfig } from '@chakra-ui/theme'

export const Z4FormError: ComponentStyleConfig = {
  parts: ['text', 'icon'],
  baseStyle: {
    text: {
      color: 'red.500',
    },
  },
}
